<template>
    <template v-if="this.checkMobileApp">
        <router-view :key="$route.path" />
    </template>
    <template v-else>
        <HeaderNonLogin v-if="!this.isNonLoginPage && !this.checkOfflinePage" />
        <div v-if="error" class="max-w-container w-full mx-auto p-0">
            <NotFound />
        </div>
        <div v-else class="max-w-container w-full mx-auto p-0">
            <main id="main" role="main" class="flex flex-col items-start p-4 lg:px-0 min-h-screen">
                <div v-if="(this.isNonLoginPage && $route.name !== 'game') || this.checkOfflinePage">&nbsp;</div>
                <div class="w-full">
                    <router-view :key="$route.path" />
                </div>
                <div v-if="this.checkOfflinePage">&nbsp;</div>
                <FooterSite
                    v-if="!this.checkOfflinePage && $route.name !== 'game'"
                    :class="contentReady ? '' : 'invisible opacity-0'"
                    class="text-center"
                />
            </main>
        </div>
    </template>
</template>

<script>
import { mapState } from 'pinia'
import { useAppStore } from '@/store/app'
import { checkOffline, checkMobileApp } from '@/utility/index'
import FooterSite from '@/components/layout/FooterSite.vue';
import HeaderNonLogin from '@/components/layout/HeaderNonLogin.vue';
import NotFound from '@/components/utilities/NotFound.vue';

export default {
    components: {
        FooterSite,
        HeaderNonLogin,
        NotFound
    },
    data() {
		return {
			error: false
		};
	},
    computed: {
        ...mapState(useAppStore, ['errorLayout', 'contentReady']),
        checkOfflinePage() {
            return checkOffline()
        },
        checkMobileApp() {
            return checkMobileApp()
        },
        isNonLoginPage() {
            return ['login', 'signup', 'recover', 'two_factor_authentication', 'game'].includes(this.$route.name)
        },
        
    },
    mounted(){
        useAppStore().setContentReady(false)
        window.addEventListener('load', () => {
            if (!useAppStore().contentReady) {
                useAppStore().setContentReady(true)
            }
        }, { once: true })
        setTimeout(() => {
            if (!useAppStore().contentReady) {
                useAppStore().setContentReady(true)
            }
        }, 1500)
    },
    watch: {
        '$route'() {
            useAppStore().setContentReady(false)
            setTimeout(() => {
                if (!useAppStore().contentReady) {
                    useAppStore().setContentReady(true)
                }
            }, 1500)
        },
        errorLayout(error) {
            this.error = error
        },
    },
}
</script>
